import { Link } from "@inertiajs/react";
import { Badge } from "@/components/ui/badge";
import type HomeClientTask from "@/types/serializers/HomeClientTask";

const CLIENTABLE_TYPE_LABELS: Record<
	HomeClientTask["clientable_type"],
	string
> = {
	IndividualClient: "Fyzická osoba",
	IndividualEntrepreneurClient: "Fyzická osoba (OSVČ)",
	BusinessClient: "Právnická osoba",
};

interface ClientTaskItemProps {
	task: HomeClientTask;
}

export function ClientTaskItem({ task }: ClientTaskItemProps) {
	return (
		<Link
			href={`/clients/${task.client_id}`}
			className="flex items-center justify-between rounded-lg border p-3 transition-colors hover:bg-muted"
		>
			<div className="flex items-center gap-2">
				<span className="font-medium">{task.client_name}</span>
				<Badge variant="outline" className="text-xs">
					{CLIENTABLE_TYPE_LABELS[task.clientable_type]}
				</Badge>
			</div>
			<span className="truncate pl-3 text-muted-foreground text-sm">
				Chybí: {task.missing_items.join(", ")}
			</span>
		</Link>
	);
}
